<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i>
              Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0);" (click)="retornoAbaRisco()"> Riscos Chaves</a>
          </li>
          <li class="breadcrumb-item active">{{titulo}} Risco Chave - {{nomeRiscoChaves}}</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<div class="card-body p-2">
  <div class="mat-elevation-z4">
    <div class="card card-outline" *ngIf="!imprimir">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
              <i *ngIf="!this.id" class="far fa-file pr-2"></i> {{titulo}} Questionário
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-4">
                <label for="pea" class="mb-1">Nome da Funcionalidade </label>
                <input type="text" disabled id="pea" class="form-control form-control-sm"
                  [value]="'Riscos Chaves v' + model?.versao" />
              </div>

              <div class="form-group col-md-2">
                <label for="siglaUg" class="mb-1">Sigla UG</label>
                <input type="text" disabled id="siglaUg" class="form-control form-control-sm"
                  [value]="model?.unidadeGestora.sigla" />
              </div>

              <div class="form-group col-md-2">
                <label for="responsavel" class="mb-1">Responsável</label>
                <input type="text" disabled id="responsavel" class="form-control form-control-sm"
                  [value]="model?.nomeResponsavel" />
              </div>

              <div class="form-group col-md-2">
                <label for="dataEnvio" class="mb-1">Data Envio</label>
                <input type="text" disabled id="dataEnvio" class="form-control form-control-sm"
                  [value]="model?.dataCriacao  | date:'dd/MM/yyyy'" />
              </div>

              <div class="form-group col-md-2">
                <label for="dataPrazo" class="mb-1">Data Prazo</label>
                <input type="text" disabled id="dataPrazo" class="form-control form-control-sm"
                  [value]="model?.dataLimite  | date:'dd/MM/yyyy'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div [class]="getStatusClass(situacao)">
        <app-print-layout [habilitado]="imprimir" (cancelar)="onCancelar()">
          <table class="mat-elevation-z8 w-100 table table-bordered">
            <thead>
              <tr>
                <th>
                  <!-- <mat-checkbox (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox> -->
                </th>
                <th>Subtipo</th>
                <th>Macroprocesso</th>
                <th>Processos</th>
                <th>Status</th>
                <th>Responsável</th>
                <th>Descrição do Risco-Chave</th>
                <th>Magnitude (Risco Inerente)</th>
                <th>Magnitude (Risco Residual)</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <!-- NOVO MODELO -->
              <ng-container *ngFor="let subtipo of modelTipoUniversoItens?.itens">
                <tr class="tr-cinza">
                  <td>
                    <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelecionado(subtipo)" color="primary"
                      (change)="onCheckboxChange($event, subtipo)" [hidden]="visualizar || imprimir"></mat-checkbox>
                  </td>
                  <td><strong>{{ subtipo.ordemExibicao }} {{ subtipo.nome }}</strong></td> <!-- Subtipo -->
                  <td></td>
                  <td></td>
                  <td>{{this.getStatus(subtipo.id)}}</td>
                  <td>{{this.getRepresentante(subtipo.id)}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <ng-container *ngFor="let macro of subtipo.itens">
                  <ng-container *ngIf="macro.tipo === 2">
                    <tr>
                      <td>
                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelecionado(macro)"
                          color="primary" (change)="onCheckboxChange($event, macro)"
                          [hidden]="visualizar || imprimir"></mat-checkbox>
                      </td>
                      <td></td>
                      <td><strong>{{ macro.ordemExibicao }} {{ macro.nome }}</strong></td> <!-- Macro Processos -->
                      <td></td>
                      <td>{{this.getStatus(macro.id)}}</td>
                      <td>{{this.getRepresentante(macro.id)}}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <ng-container *ngIf="getMagnitude(macro.itens) as magnitude">
                      <ng-container *ngFor="let processo of macro.itens">
                        <ng-container *ngIf="getRiscosPorProcesso(processo.id) as riscos">
                          <ng-container *ngFor="let risco of riscos; let i = index">
                            <tr>
                              <ng-container *ngIf="i === 0">
                                <td [attr.rowspan]="riscos.length" *ngIf="(riscos.length == 1)">
                                  <mat-checkbox (click)="checkIt(processo,riscos.length)" color="primary"
                                    [checked]="isSelecionado(processo)"
                                    [hidden]="visualizar || imprimir"></mat-checkbox>
                                </td>
                                <td [attr.rowspan]="riscos.length" *ngIf="(riscos.length > 1)">
                                  <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelecionado(processo)"
                                    color="primary" (change)="onCheckboxChange($event, processo)"
                                    [hidden]="visualizar || imprimir"></mat-checkbox>
                                </td>
                              </ng-container>
                              <td></td>
                              <td></td>
                              <ng-container *ngIf="i === 0">
                                <td [attr.rowspan]="riscos.length">
                                  {{ processo.ordemExibicao }} {{ processo.nome }}
                                </td>
                              </ng-container>
                              <td>{{this.getStatus(processo.id)}}</td>
                              <td>{{this.getRepresentante(processo.id)}}</td>
                              <td>{{ risco.nomeRisco }}</td>
                              <td>{{ risco.ri || 0 }}</td>
                              <td>{{ risco.rr || 0 }}</td>
                              <td class="botoes-acoes">
                                <button type="button" class="btn btn-info btn-xs mr-1"
                                  (click)="abrirPreenchimento(processo.id, true, subtipo.ordemExibicao + ' ' + subtipo.nome, macro.ordemExibicao + ' ' + macro.nome, processo.ordemExibicao + ' ' + processo.nome)">
                                  <i class="far fa-eye"></i>
                                </button>
                                <button type="button" class="btn btn-primary btn-xs mr-1" [hidden]="visualizar"
                                  (click)="abrirPreenchimento(processo.id, false, subtipo.ordemExibicao + ' ' + subtipo.nome, macro.ordemExibicao + ' ' + macro.nome, processo.ordemExibicao + ' ' + processo.nome)">
                                  <i class="far fas fa-pen"></i>
                                </button>
                              </td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="getMagnitude([processo]) as magProc">
                            <tr>
                              <td></td>
                              <td></td>
                              <td colspan="2" class="text-left"><strong>Magnitude</strong></td>
                              <td><strong>{{ magProc.riTotal }}</strong></td>
                              <td><strong>{{ magProc.rrTotal }}</strong></td>
                              <td></td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="getMagnitudeMacro(subtipo.itens) as magnitudeSubtipo">
                  <tr>
                    <td></td>
                    <td></td>
                    <td><strong>Magnitude</strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><strong>{{ magnitudeSubtipo.riTotal }}</strong></td>
                    <td><strong>{{ magnitudeSubtipo.rrTotal }}</strong></td>
                    <td></td>
                  </tr>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="getMagnitudeTotal() as magnitudeTotal">
                <tr>
                  <td></td>
                  <td><strong>Magnitude</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ magnitudeTotal.riTotal }}</strong></td>
                  <td><strong>{{ magnitudeTotal.rrTotal }}</strong></td>
                  <td></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </app-print-layout>
      </div>
    </div>
    <div class="card-footer">
      <div class="btn-group" [hidden]="visualizar || imprimir">
        <button type="button" class="btn btn-primary btn-sm">
          <i class="far fa-save"></i> Salvar
        </button>
        <button type="button" class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split"
          data-toggle="dropdown" aria-expanded="false">
        </button>
        <div class="dropdown-menu" role="menu">
          <a class="dropdown-item" (click)="onSalvar(false)">Salvar</a>
          <a class="dropdown-item" (click)="onSalvar(true)">Salvar e fechar</a>
        </div>
      </div>

      <button type="button" *ngIf="!visualizar && !imprimir" class="btn btn-warning btn-sm mr-1 ml-1"
        [disabled]="!canEnviar()" (click)="onEnviar()">
        <i class="fas fa-paper-plane"></i> Enviar
      </button>

      <button type="button" *ngIf="!visualizar && !imprimir" class="btn btn-success btn-sm mr-1" (click)="onFinalizar()"
        [disabled]="!(selectedIds.length > 0)">
        <i class="fas fa-list"></i> Finalizar
      </button>

      <button type="button" *ngIf="!visualizar && !imprimir" class="btn btn-default btn-sm mr-1" (click)="onCancelar()">
        <i class="fas fa-times"></i> Cancelar
      </button>

      <button type="button" *ngIf="!visualizar && !imprimir" class="btn btn-danger btn-sm mr-1"
        (click)="modalDelegar()">
        <i class="fas fa-share-square"></i> Delegar
      </button>

      <button type="button" *ngIf="visualizar" class="btn btn-default btn-sm" (click)="onCancelar()">
        <i class="fas fa-times"></i> Sair
      </button>

    </div>
  </div>